import { useTranslation } from 'react-i18next';
import { isGlobant } from 'utils/contants';
import config from '../../../../../config';
import { checkUser } from '../../../../../utils/checkUser';
import Form, { Input, SubmitButton, TextArea } from '../../../../molecules/Form';
import GooglePlaceAutocomplete from '../../../../molecules/Form/components/GooglePlaceAutocomplete';
import SubmitHomeButton from '../../../../molecules/Form/components/SubmitHomeButton';
import CompanySelect from './Components/CompanySelect';
import GenderSelect from './Components/GenderSelect';
import IdTypeSelect from './Components/IdTypeSelect';
import MaritalSelect from './Components/MaritalSelect';
import NationalitySelect from './Components/NationalitySelect';
import StateOfArSelect from './Components/StateOfArSelect';
import useChageProfile from './hook/useChageProfile';
import { handleBlur, handleFocus } from 'utils/contants';
import { useState } from 'react';
import ProfileImageUpload from './Components/ProfileImageUpload';

const getAdress = (addresses) => {
  if (!addresses || !addresses.length) return { address: '', address_info: '' };

  const lastAdress = addresses[addresses.length - 1];

  return { address_id: lastAdress.id, address: lastAdress.name, address_info: lastAdress.info };
};

const columnClasses = 'form-group  col-md-6';
const noEditableOptionalFields = ['optional_field_one', 'optional_field_two'];
const MyPersonalData = ({ user }) => {
  const { t } = useTranslation();
  const [currentImage, setCurrentImage] = useState(null);
  const {
    name,
    surname,
    email,
    id,
    volunteeringFields = {},
    addresses = [],
    talent = {},
    volunteeringOptionalFields = {},
  } = user;

  console.log(user);

  const defaultValue = {
    name,
    surname,
    email,
    id,
    image: talent.image || '',
    title: talent.title || '',
    short_description: talent.short_description || '',
    ...volunteeringFields,
    ...volunteeringOptionalFields,

    ...getAdress(addresses),
  };

  const { change, isLoading, error, update, birthdateError, setBirthdateError } = useChageProfile(false);

  const handleImageChange = (file) => {
    setCurrentImage(file);
  };

  const handleSubmit = async (values) => {
    const today = new Date();
    const birthdate = new Date(values.birthday);

    if (birthdate > today) {
      setBirthdateError(true);
      return;
    }

    try {
      const formData = new FormData();
      formData.append('id', user.id);

      if (currentImage) {
        formData.append('image', currentImage);
      } else if (values.image) {
        formData.append('image', values.image);
      }

      formData.append('title', values.title || '');
      formData.append('short_description', values.short_description || '');

      await update({
        endpoint: 'profile/talents',
        data: formData,
        isFormData: true,
      });

      // Extraer los optional_field_x
      const volunteeringOptionalFields = {};
      Object.entries(values).forEach(([key, val]) => {
        if (key.startsWith('optional_field_')) {
          volunteeringOptionalFields[key] = val;
        }
      });

      // Enviar el resto de campos excluyendo image, title, description y optional_fields
      const { image, title, short_description, ...rest } = values;

      await update({
        endpoint: 'profile',
        data: {
          ...rest,
          volunteering_optional_fields: volunteeringOptionalFields,
        },
      });
    } catch (err) {
      console.error('Error en la actualización del perfil:', err);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow bg-white rounded">
        <div
          className={`card-header ${!config.profile_globant && 'bg-white fw-bold'}`}
          style={{
            borderBottom: !config.profile_globant ? '2px solid var(--primary)' : 'none',
            fontWeight: !config.profile_globant ? 600 : 'normal',
          }}
        >
          {t('profile.profile_msg')}
        </div>
        <div className="card-block">
          <div className="card-body">
            <Form submit={handleSubmit} defaultValue={defaultValue}>
              <div>
                <div className={`d-flex flex-column ${!config.profile_globant && 'flex-lg-row'}`}>
                  {!config.profile_globant && (
                    <div className="col-md-12 col-lg-4">
                      <div className={`form-group mb-0`}>
                        <ProfileImageUpload
                          currentImage={currentImage}
                          onImageChange={handleImageChange}
                          userImage={talent.image}
                          name={name}
                        />
                      </div>

                      {!config.exception && !config.profile_globant && (
                        <div className="form-group">
                          <Input label={t('profile.profile_msg12')} name="linkedin_url" type="text" validations={[]} />
                        </div>
                      )}
                      {config.catalogTalents && (
                        <>
                          <div className="form-group">
                            <Input label={t('profile.portfolio')} name="portfolio_url" type="text" validations={[]} />
                          </div>
                          <div className="form-group">
                            <Input
                              label={t('profile.curriculum')}
                              name="curriculum_url"
                              type="text"
                              validations={[]}
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  )}
                  <div className={config.profile_globant ? 'w-100' : 'col-lg-8'}>
                    <div className={config.profile_globant ? 'd-flex flex-column' : 'row'}>
                      <div className={`form-group ${!config.profile_globant && ' col-md-6'}`}>
                        <Input
                          label={t(config.profile_globant ? 'profile.name_lastname' : 'profile.name')}
                          name="name"
                          type="text"
                          validations={[
                            { key: 'required', val: true },
                            { key: 'max_length', val: 50 },
                          ]}
                          onFocus={handleFocus}
                          onBlur={handleBlur}
                        />
                      </div>
                      {!config.profile_globant && (
                        <div className={columnClasses}>
                          <Input
                            label={t('profile.surname')}
                            name="surname"
                            type="text"
                            validations={[
                              { key: 'required', val: true },
                              { key: 'max_length', val: 50 },
                            ]}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                          />
                        </div>
                      )}
                      <div className={`form-group ${config.profile_globant ? 'col-lg-4 col-md-6 px-0' : ' col-md-6'}`}>
                        <Input
                          label={t('profile.email')}
                          name="email"
                          type="email"
                          validations={[
                            { key: 'required', val: true },
                            { key: 'email', val: true },
                          ]}
                        />
                      </div>
                      {/* Fecha de nacimiento */}
                      {!config.profile_globant && (
                        <div className={columnClasses}>
                          <Input label={t('profile.profile_msg8')} name="birthday" type="date" validations={[]} />
                        </div>
                      )}
                      {/* Tipo de doc y nro */}
                      {!config.profile_globant && (
                        <>
                          <div className={columnClasses}>
                            <IdTypeSelect />
                          </div>
                          <div className={columnClasses}>
                            <Input
                              label={t('profile.profile_msg7')}
                              name="id_number"
                              type="text"
                              validations={[
                                { key: 'required', val: true },
                                { key: 'max_length', val: 50 },
                              ]}
                            />
                          </div>
                        </>
                      )}
                      {/* Estado civil */}
                      {!config.exception && !config.profile_globant && (
                        <div className={columnClasses}>
                          <MaritalSelect />
                        </div>
                      )}
                      {/* Género */}
                      {!config.profile_globant && (
                        <div className={columnClasses}>
                          <GenderSelect />
                        </div>
                      )}
                      {/* Empresa a la que perteneces */}
                      {config.companyTypes && (
                        <div className={columnClasses}>
                          <CompanySelect />
                        </div>
                      )}
                      {/* Nacionalidad */}
                      {!config.profile_globant && (
                        <div className={columnClasses}>
                          {' '}
                          <NationalitySelect />
                        </div>
                      )}
                      {/* Teléfono */}
                      {!config.profile_globant && (
                        <div className={columnClasses}>
                          <Input
                            label={t('profile.profile_msg10')}
                            name="phone_number"
                            type="number"
                            validations={[{ key: 'max_length', val: 25 }]}
                          />
                        </div>
                      )}
                      {/* Teléfono adicional */}
                      {!config.profile_globant && (
                        <div className={columnClasses}>
                          <Input
                            label={t('profile.profile_msg11')}
                            name="mobile_number"
                            type="number"
                            validations={[{ key: 'max_length', val: 25 }]}
                          />
                        </div>
                      )}
                      {/* Domicilio */}
                      {!config.withState && !config.profile_globant && (
                        <div className="form-group col-md-6">
                          <GooglePlaceAutocomplete
                            label={t('profile.profile_msg13')}
                            name="address"
                            validations={[{ key: 'required', val: true }]}
                          />
                        </div>
                      )}
                      {/* Detalles adicionales a la dirección */}
                      {!config.withState && !config.profile_globant && (
                        <div className="form-group col-md-6">
                          <Input label={t('profile.profile_msg14')} name="address_info" type="text" validations={[]} />
                        </div>
                      )}
                      {/* Provincia y localidad */}
                      {!config.exception && config.withState && (
                        <div className="form-group col-md-12">
                          <StateOfArSelect />
                        </div>
                      )}
                      {/* Detalles adicionales a la dirección */}
                      {!config.exception && config.withState && (
                        <div className="form-group col-md-6">
                          <Input label={t('profile.profile_msg14')} name="address_info" type="text" validations={[]} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className={config.profile_globant ? 'd-flex flex-column' : 'row'}>
                  {config.userVolunteeringFields &&
                    Object.entries(config.optionalFields)
                      .filter(([_, label]) => label && label.trim() !== '')
                      .map(([key, label]) => {
                        const value = user.volunteeringOptionalFields?.[key] || '';
                        const noEditable = noEditableOptionalFields.includes(key);

                        return (
                          <div className="form-group col-md-4 mb-3" key={key}>
                            <Input label={label} name={key} validations={[]} readOnly={noEditable} />
                          </div>
                        );
                      })}
                </div>
                {!config.profile_globant && config.catalogTalents && (
                  <div>
                    <div className="form-group col-md-12">
                      <Input
                        label="Rol"
                        name="title"
                        type="text"
                        validations={[
                          { key: 'required', val: true },
                          { key: 'max_length', val: 100 },
                        ]}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <TextArea
                        label="Descripción"
                        name="short_description"
                        type="text"
                        validations={[
                          { key: 'required', val: false },
                          { key: 'max_length', val: 420 },
                        ]}
                      />
                    </div>
                  </div>
                )}
              </div>

              <SubmitButton isloading={isLoading} />
              {config.profile_globant && <SubmitHomeButton isloading={isLoading} canRedirect={change} />}
            </Form>
          </div>
        </div>
      </div>
      {error && (
        <div className="alert alert-danger" role="alert">
          {t('profile.extra_msg1')}
        </div>
      )}
      {birthdateError && (
        <div className="alert alert-danger" role="alert">
          {t('profile.birthdate_error')}
        </div>
      )}
      {change && (
        <div className="alert alert-success" role="alert">
          {t('profile.extra_msg2')}
        </div>
      )}
      {!change && !checkUser(user).length && !isGlobant && (
        <div className="alert alert-warning" role="alert">
          {t('profile.extra_msg3')}
        </div>
      )}
    </div>
  );
};
export default MyPersonalData;
